import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import InicioEncuesta from "./pages/InicioEncuesta";
import EncuestaIndividualDesactivada from "./pages/EncuestaIndividualDesactivada";
import Encuesta4C from "./pages/Encuesta4C";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<InicioEncuesta />} />
        <Route path="/test" element={<EncuestaIndividualDesactivada />} />
        <Route path="/encuesta" element={<Encuesta4C />} />
        <Route path="/encuesta-4creatividades" element={<Encuesta4C />} />
      </Routes>
    </Router>
  );
}

export default App;
